import { Injectable } from '@angular/core';
import { BaseApiService } from '../services/base-api.service';

@Injectable({ providedIn: 'root' })
export class FeatureToggleService {
  constructor(private baseApiService: BaseApiService) {}

  public isEnabled(featureCode: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.baseApiService.getEnabledFeatureToggles()
      ?.subscribe(
        (res) => {
          resolve(res.featureCodes.some((code) => code.toLowerCase() === featureCode.toLowerCase()));
        },
        (err) => {
          reject(err);
        });
    });
  }
}
